module.exports = function() {
  return new Worker(__webpack_public_path__ + "fieldSettings.worker.4b0aa9c5.worker.js");
};